import React, { FunctionComponent } from 'react'
import { toast } from 'react-toastify'
import styled from 'styled-components'

import { NotificationDelay } from '../../common/types'
import { Icon } from '../icons/Icon'
import { Container, Content, IconWrapper, Message, Title } from './styles'
import { dismissToast } from '.'
import { formatMessageSafe } from '../../util/translateInputOptions'
import { defineMessages, useIntl } from 'react-intl'

const toastId = 'status_change_forbidden'

const messages = defineMessages({
  statusChangeForbiddenTitle: {
    id: 'containers.graphql.status_change_forbidden.title',
    defaultMessage: 'Status change forbidden',
  },
  statusChangeForbiddenMessage: {
    id: 'containers.graphql.status_change_forbidden.message',
    defaultMessage: 'Status may have already changed',
  },
})

export const setStatusChangeForbiddenNotification = (message: string) => {
  if (!toast.isActive(toastId)) {
    toast.error(<StatusChangeForbiddenNotification message={message} />, {
      toastId,
      autoClose: false,
      closeButton: false,
      delay: 0,
    })
    dismissToast(toastId, NotificationDelay.statusChangeForbiddenNotificationDelay)
  }
}

interface Props {
  message: string
}

const StatusChangeForbiddenNotificationIntl: FunctionComponent<Props> = () => {
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)

  return (
    <StatusChangeForbiddenNotificationContainer>
      <IconWrapper>
        <Icon size="big" icon={'lock'} color="red900" />
      </IconWrapper>
      <Content>
        <Title>{formatMessage(messages.statusChangeForbiddenTitle)}</Title>
        <Message>{formatMessage(messages.statusChangeForbiddenMessage)}</Message>
      </Content>
    </StatusChangeForbiddenNotificationContainer>
  )
}

const StatusChangeForbiddenNotificationContainer = styled(Container as any)`
  background-color: ${props => props.theme.colors.red100};
  color: ${props => props.theme.colors.red900};
  border-bottom: 1px solid ${props => props.theme.colors.red500};
`

export const StatusChangeForbiddenNotification = StatusChangeForbiddenNotificationIntl
